<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ id > 0 ? "Editar" : "Adicionar" }} Categorias
        </h2>

        <v-row>
          <v-col>
            <ComboboxTerritoriosFases
              :value="eixo"
              ref="fase"
              :rules="rules"
            ></ComboboxTerritoriosFases>
          </v-col>
          <v-col>
            <v-text-field
              label="Nome"
              name="tipo"
              type="text"
              v-model="eixo.nomeCategoria"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import { territoriosCategoriaAPI } from "@/modules/gestao-territorios/API/territoriosCategoriaAPI";
import ComboboxTerritoriosFases from "../fases/ComboboxTerritoriosFases.vue";

export default {
  components: {
    ComboboxTerritoriosFases,
  },
  data() {
    return {
      eixo: {},
      isEdit: false,
      tabType: this.$route.params.tab,
      id: this.$route.params.id,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {
    if (this.id > 0) {
      this.setLoading(true);
      territoriosCategoriaAPI
        .get(this.id)
        .then(({ data }) => {
          this.eixo = data;

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Governança");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(`/gestao-territorios/${this.tabType}`);
    },
    async onSubmit() {
      const valid = await this.check();
      const validFase = await this.$refs.fase.check();
      if (!valid || !validFase) return;
      this.setLoading(true);

      if (this.id > 0) {
        territoriosCategoriaAPI
          .update(this.eixo)
          .then(() => {
            this.$notification.success("Categoria editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Categoria");
            console.log("Erro no submit ", err);
          });
      } else {
        territoriosCategoriaAPI
          .create(this.eixo)
          .then(() => {
            this.$notification.success("Categoria criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Categoria");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
